<template>
  <Card cardClasses="shadow-sm border-0">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="m-0 text-primary">
        <i class="bi bi-person me-2"></i>Customer Details
      </h4>
      <div>
        <button class="btn btn-outline-secondary" @click="$router.go(-1)">
          <i class="bi bi-arrow-left me-1"></i> Back
        </button>
      </div>
    </div>

    <div class="container-fluid p-0">
      <!-- Loader -->
      <div v-if="loading" class="text-center py-5">
        <Spinner spinner-class="mb-1" />
        <p class="text-muted mt-2">Loading customer details...</p>
      </div>

      <!-- Content -->
      <div v-if="!loading" class="customer-details-content fade-in">
        <div class="text-center mb-4">
          <h2 class="customer-title">{{ customer.name }}</h2>
        </div>

        <div class="card border-0 shadow-sm mb-4">
          <div class="card-header bg-light py-3">
            <h5 class="mb-0"><i class="bi bi-info-circle me-2"></i>Customer Information</h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6 col-lg-3">
                <div class="info-group">
                  <h6 class="info-label">Email</h6>
                  <p class="info-value">{{ customer.email || 'Not provided' }}</p>
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <div class="info-group">
                  <h6 class="info-label">Phone</h6>
                  <p class="info-value">{{ customer.phone }}</p>
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <div class="info-group">
                  <h6 class="info-label">Address</h6>
                  <p class="info-value">{{ customer.address || 'Not provided' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex justify-content-center gap-3 mt-4 mb-3">
          <button class="btn btn-outline-secondary px-4" @click="$router.go(-1)">
            <i class="bi bi-arrow-left me-1"></i> Back
          </button>
          <button v-if="profile.role !== 'user'" class="btn btn-primary px-4" @click="$router.push('/edit-customer/' + $route.params.id)">
            <i class="bi bi-pencil me-1"></i> Edit Customer
          </button>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import customerService from "@/api/customerService";
import {decrypt} from "@/utils/crypto";

export default {
  name: "CustomerDetails",
  data(){
    return {
      profile: {},
      loading: true,
      customer: {},
    }
  },
  methods:{
    async getCustomer(){
      try {
        this.customer = await customerService.getCustomer(this.$route.params.id);
      } catch(e){ console.error(e); } finally { this.loading = false; }
    }
  },
  async created(){
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    await this.getCustomer();
  }
}
</script>

<style scoped>
.customer-details-content{ padding:0.5rem; }
.customer-title{ font-weight:600; color:#333; margin-bottom:0.5rem; }
.info-group{ margin-bottom:0.5rem; }
.info-label{ font-weight:600; font-size:0.85rem; color:#555; }
</style>
